import type en from "../en/aiadmin";
import type { Messages } from "../../types";

const fr: Messages<typeof en> = {
  statusVoices: "Voix d’appel naturelles (labo des voix)",
  statusVoicesHint: "Comparez les voix ElevenLabs, Hakim, Gemini, Cartesia et OpenAI et choisissez-en une par dialecte et genre. Sinon, les appels utilisent les voix du navigateur.",
  personaPortraits: "Portraits des personas d’appel IA (Flux)",
  metaTitle: "IA et crédits",
  title: "IA et crédits",
  description: "Choisissez quelles fonctions IA sont gratuites, leur coût en crédits, ce que chaque forfait inclut chaque mois et les packs de crédits que les marchands peuvent acheter.",

  statusTitle: "État",
  statusDesc: "Les intégrations se configurent via des variables d’environnement sur le serveur. Les valeurs secrètes ne sont jamais affichées ici.",
  statusConfigured: "Configuré",
  statusMissing: "Non configuré",
  statusClaude: "IA texte — OpenAI GPT ou Claude (prompts, appels, traduction)",
  statusClaudeHint: "Utilise OpenAI quand une clé OpenAI est enregistrée dans Labo des voix → Fournisseurs (ou si {vars} est défini) ; sinon Claude avec ANTHROPIC_API_KEY.",
  statusImages: "Images IA (Flux)",
  imagesFlux: "Flux sur Replicate crée les photos des boutiques.",
  imagesOpenai: "Pas de jeton Replicate : les images OpenAI sont utilisées (clé OpenAI). Ajoutez un jeton Replicate pour utiliser Flux.",
  imagesNone: "Ajoutez un jeton Replicate (Flux) ou une clé OpenAI dans le Voice Lab pour créer les photos produits.",
  imageKeyLabel: "Jeton API Replicate",
  imageKeySavedPlaceholder: "Jeton enregistré — collez-en un nouveau pour le remplacer",
  imageKeySave: "Enregistrer le jeton",
  imageKeyRemove: "Supprimer le jeton enregistré",
  imageKeyHelp: "À obtenir sur replicate.com → Account → API tokens. Stocké chiffré, jamais réaffiché.",
  imageTest: "Tester la génération d'images",
  imageTestOk: "{provider} fonctionne : une image de test a été créée ({kb} Ko en {s} s).",
  imageTestFailed: "Échec de {provider} : {error}",
  imageKeySaved: "Jeton d'images enregistré.",
  imageKeyRemoved: "Jeton d'images supprimé.",
  statusImagesHint: "Définissez {vars}.",
  statusStripe: "Stripe plateforme (achat de crédits)",
  statusStripeHint: "Définissez {vars}. Sans cela, les marchands ne peuvent pas acheter de crédits en ligne — vous pouvez toujours en accorder manuellement.",
  statusWebhookMissing: "Le secret du webhook est manquant : les achats ne seront crédités que lorsque l’acheteur revient sur le site.",

  usageTitle: "Utilisation et revenus",
  statSold: "Crédits vendus",
  statRevenue: "Revenus des crédits",
  statSpent: "Crédits consommés",
  statOutstanding: "Crédits inutilisés",
  statOutstandingSub: "Somme de tous les soldes",
  statPrompts: "Prompts IA",
  statMinutes: "Minutes d’appel",
  statImages: "Images IA",
  statThisMonth: "Ce mois-ci",
  statAllTime: "Depuis le début",

  pricingTitle: "Gratuit ou payant",
  pricingDesc: "Les fonctions gratuites n’utilisent jamais de crédits. Les fonctions payantes utilisent d’abord le quota mensuel inclus dans le forfait du marchand, puis des crédits.",
  feature_prompt: "Prompts IA",
  feature_call: "Appels vocaux",
  feature_image: "Images IA",
  feature_translation: "Traduction IA",
  featureDesc_prompt: "Requêtes à l’assistant IA de la boutique.",
  featureDesc_call: "Appels vocaux en direct avec l’assistant IA.",
  featureDesc_image: "Images de produits et bannières générées.",
  featureDesc_translation: "Traduction automatique du contenu de la boutique.",
  modeFree: "Gratuit pour tous",
  modeMetered: "Payant — quota du forfait, puis crédits",
  cost_prompt: "Crédits par requête (niveau Moyen)",
  cost_call: "Crédits par minute (niveau Moyen)",
  cost_image: "Crédits par image",
  cost_translation: "Crédits par élément",
  costHintLevel: "Multiplié par le multiplicateur de prix du niveau.",
  costHintNoAllowance: "Les forfaits n’incluent pas de quota de traduction gratuit : les crédits sont débités dès le premier élément.",
  signupCredits: "Crédits offerts à l’inscription",
  signupCreditsHint: "Accordés une seule fois à chaque nouveau compte.",
  lowBalance: "Alerte de solde bas",
  lowBalanceHint: "Les marchands sont avertis lorsque leur solde passe sous ce nombre de crédits.",

  levelsTitle: "Niveaux de modèle",
  levelsDesc: "Chaque niveau correspond à un modèle et un effort. Utilisez des modèles OpenAI (gpt-5-mini, gpt-5…) ou Claude (claude-haiku-5-5…). Si le modèle d’un niveau appartient au fournisseur inactif, le modèle par défaut du fournisseur actif est utilisé (Low/Medium : gpt-5-mini, High/Max : gpt-5). Le multiplicateur de prix ajuste le coût en crédits.",
  level_low: "Bas",
  level_medium: "Moyen",
  level_high: "Élevé",
  level_max: "Max",
  colLevel: "Niveau",
  colEnabled: "Activé",
  colModel: "Modèle",
  colEffort: "Effort",
  colMultiplier: "Multiplicateur de prix",
  effort_low: "Faible",
  effort_medium: "Moyen",
  effort_high: "Élevé",
  defaultLevel: "Niveau par défaut",
  defaultLevelHint: "Utilisé quand le marchand ne choisit pas de niveau. Il doit être activé.",
  enableLevel: "Activer {level}",
  saveSettings: "Enregistrer les réglages IA",
  settingsSaved: "Réglages IA enregistrés.",
  invalidSettings: "Impossible de lire les réglages. Rechargez la page et réessayez.",

  plansTitle: "Quotas par forfait",
  plansDesc: "Ce qui est gratuit chaque mois, par forfait. Les fonctions payantes utilisent ce quota avant de débiter des crédits.",
  freeUsers: "Utilisateurs gratuits",
  inactive: "Inactif",
  freePrompts: "Prompts gratuits / mois",
  freeCallMinutes: "Minutes d’appel gratuites / mois",
  freeImages: "Images gratuites / mois",
  maxLevel: "Niveau maximal",
  savePlan: "Enregistrer",
  planSaved: "Quota enregistré.",
  noPlans: "Aucun forfait pour l’instant.",

  packsTitle: "Packs de crédits",
  packsDesc: "Packs que les marchands peuvent acheter par carte (Stripe Checkout sur le compte de la plateforme).",
  addPack: "Ajouter un pack",
  editPack: "Modifier",
  editPackTitle: "Modifier le pack de crédits",
  newPackTitle: "Nouveau pack de crédits",
  colPack: "Pack",
  colPrice: "Prix",
  colCredits: "Crédits",
  colBonus: "Bonus",
  colBadge: "Badge",
  colStatus: "Statut",
  colOrder: "Ordre",
  packLabel: "Libellé",
  packLabelHint: "Facultatif, par ex. « Pack de démarrage ».",
  packCurrency: "Devise",
  packPrice: "Prix",
  packCredits: "Crédits",
  packBonus: "Crédits bonus",
  packBadge: "Badge",
  badgeNone: "Aucun",
  badge_popular: "Populaire",
  badge_best_value: "Meilleure offre",
  packActive: "Disponible à l’achat",
  packOrder: "Ordre d’affichage",
  savePack: "Enregistrer le pack",
  packSaved: "Pack de crédits enregistré.",
  noPacks: "Aucun pack de crédits. Ajoutez-en un pour que les marchands puissent acheter des crédits.",
  active: "Actif",
  untitledPack: "{credits} crédits",

  userCreditsTitle: "Crédits",
  userCreditsDesc: "Portefeuille de crédits IA de ce compte.",
  balance: "Solde",
  purchased: "Achetés",
  spent: "Consommés",
  granted: "Offerts",
  noAccount: "Pas encore de portefeuille — il est créé la première fois que cet utilisateur utilise l’IA ou reçoit des crédits.",
  recentLedger: "Mouvements récents",
  colWhen: "Date",
  colKind: "Type",
  colChange: "Variation",
  colBalanceAfter: "Solde après",
  colReason: "Motif",
  kind_signup: "Bonus d’inscription",
  kind_purchase: "Achat",
  kind_spend: "Utilisation",
  kind_refund: "Remboursement",
  kind_admin: "Ajustement admin",
  noLedger: "Aucun mouvement de crédits.",
  adjustTitle: "Ajuster les crédits",
  adjustDelta: "Crédits",
  adjustDeltaHint: "Positif pour ajouter, négatif pour retirer (ex. 500 ou -200).",
  adjustReason: "Motif",
  adjustReasonHint: "Obligatoire — enregistré dans le registre et le journal d’audit.",
  adjustSubmit: "Appliquer l’ajustement",
  adjustDone: "Crédits ajustés. Nouveau solde : {balance}.",
  adjustInvalid: "Saisissez un nombre entier de crédits différent de zéro.",
  adjustReasonRequired: "Un motif est obligatoire.",
};

export default fr;
